// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Dynamic theming */
    --body-background-color: var(--config-body-background-color, var(--color-primary-white));

    /* Spacing */
    --unit: 4px;

    /* Base */
    --color-primary-black: #000000;
    --color-primary-white: #FFFFFF;

    /* Red */
    --color-primary-red-100: #E02900;
    --color-primary-red-200: #B62202;
    --color-primary-red-300: #7B1701;

    /* Gray */
    --color-neutrals-gray-100: #4C4C4C;
    --color-neutrals-gray-300: #BDBDBD;
    --color-neutrals-gray-400: #F2F2F2;

    /* Feedback */
    --color-feedback-info: #EBF7FF;
    --color-feedback-info-border: #C8E6FA;
    --color-feedback-error: #FFEBE7;
    --color-feedback-error-border: #FFD9D2;

    /* Radius */
    --radius-pill: 999px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/variables.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,wFAAwF;;IAExF,YAAY;IACZ,WAAW;;IAEX,SAAS;IACT,8BAA8B;IAC9B,8BAA8B;;IAE9B,QAAQ;IACR,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;;IAEhC,SAAS;IACT,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;;IAElC,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,+BAA+B;IAC/B,sCAAsC;;IAEtC,WAAW;IACX,oBAAoB;AACxB","sourcesContent":[":root {\n    /* Dynamic theming */\n    --body-background-color: var(--config-body-background-color, var(--color-primary-white));\n\n    /* Spacing */\n    --unit: 4px;\n\n    /* Base */\n    --color-primary-black: #000000;\n    --color-primary-white: #FFFFFF;\n\n    /* Red */\n    --color-primary-red-100: #E02900;\n    --color-primary-red-200: #B62202;\n    --color-primary-red-300: #7B1701;\n\n    /* Gray */\n    --color-neutrals-gray-100: #4C4C4C;\n    --color-neutrals-gray-300: #BDBDBD;\n    --color-neutrals-gray-400: #F2F2F2;\n\n    /* Feedback */\n    --color-feedback-info: #EBF7FF;\n    --color-feedback-info-border: #C8E6FA;\n    --color-feedback-error: #FFEBE7;\n    --color-feedback-error-border: #FFD9D2;\n\n    /* Radius */\n    --radius-pill: 999px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
